import "./SideMenu.css"
import {Link} from 'react-router-dom';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from '@mui/icons-material/Call';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {ReactComponent as DialPhoneIcon} from "../../dialPhoneIcon.svg";

export default function SideMenu() {

    return (
        <div id="sidemenuContainer">
            <div id="menuButtonContainer">
                {/*<Link id="menuButton" to="/filter/grani">*/}
                {/*    GRANI*/}
                {/*</Link>*/}
                <Link id="menuButton" to="/filter/cialde">
                    CIALDE
                </Link>
                <Link id="menuButton" to="/filter/capsule_compatibili_nespresso">
                    NESPRESSO
                </Link>
                <Link id="menuButton" to="/filter/capsule_compatibili_modo_mio">
                    A MODO MIO
                </Link>
                <Link id="menuButton" to="/filter/macchinette">
                    MACCHINETTE
                </Link>
                <Link id="menuButton" to="/filter/altri_prodotti">
                    ALTRI PRODOTTI
                </Link>
            </div>
            <div id="contactLinkContainer">
                <div id="contactLinkButton" className="whatsappButton">
                    <a href={"https://wa.me/393335731595?text=Salve,%20la%20contatto%20per%20ricevere%20maggiori%20informazioni%20riguardo%20un%20prodotto%20visualizzato%20sul%20vostro%20sito%20web."}>
                        <WhatsAppIcon fontSize="large"/> WHATSAPP
                    </a>
                </div>
                <div id="contactLinkButton" className="telephoneButton">
                    <a href={"tel:+393335731595"}>
                        <CallIcon fontSize="large"/> CELLULARE
                    </a>
                </div>
                <div id="contactLinkButton" className="phoneButton">
                    <a href={"tel:+390803148778"}>
                        <DialPhoneIcon /> TELEFONO
                    </a>
                </div>
                <div id="contactLinkButton" className="mapsButton">
                    <a href={"https://www.google.com/maps/dir//Via+Enrico+Toti,+2,+70022+Altamura+BA/@40.8326393,16.4725415,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x13478774533569cf:0xd3c0200ebf623682!2m2!1d16.554933!2d40.832673?hl=it&entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoJLDEwMjExNjQwSAFQAw%3D%3D"}>
                        <LocationOnIcon fontSize="large"/> POSIZIONE
                    </a>
                </div>
            </div>

        </div>
    )
}